<script>
    import Button from "./Button.svelte";
    export let isLoggedIn = false;

    import { createEventDispatcher } from "svelte";
    import { t } from "../i18n";
    const dispatch = createEventDispatcher();
</script>

<!--src/components/Header.svelte-->
<header>
    <div class="header flex-with-page">
        <img class="topBarLogo" src="./assets/brand_logo.svg?v=1631144737" alt="AdBlock Logo" />
        {#if isLoggedIn}
            <Button
                on:click="{() => dispatch('message', { action: 'LOGOUT' })}"
                classNames="{'secondary hover-style short light-bg'}"
                buttonText="{$t('sign_out')}"
                flex="{'0 1 200px'}"
            />
        {/if}
    </div>
</header>

<style>
    header {
        background-color: var(--backgroundColorLightest);
        box-shadow: none;
        line-height: 22px;
        padding: 16px;
        color: var(--textColorDarkest);
        border-radius: 6px;
        width: 100%;
        min-height: 88px;
        flex: none;
        padding: 16px;
        min-height: 88px;
        background-color: var(--backgroundColorLightest);
    }
    header img {
        height: 56px;
        width: auto;
        flex: 0 1 48px;
    }
    div {
        background-color: inherit;
    }
</style>
